export const LEADS_TOOLS = [
  'relevar_datos',
  'derivar_comercial',
  'registrar_interes_reunion',
  'cerrar_fuera_de_mercado',
  'derivar_humano',
] as const;

export type LeadsToolName = (typeof LEADS_TOOLS)[number];

export const LEADS_TOOL_LABELS: Record<LeadsToolName, string> = {
  relevar_datos: 'Relevar datos del prospecto',
  derivar_comercial: 'Derivar al comercial',
  registrar_interes_reunion: 'Registrar interés en reunión',
  cerrar_fuera_de_mercado: 'Cerrar fuera de mercado',
  derivar_humano: 'Derivar a humano',
};

export const LEADS_TOOL_DESCRIPTIONS: Record<LeadsToolName, string> = {
  relevar_datos: 'Persiste slots propuestos y devuelve la próxima acción del orquestador.',
  derivar_comercial: 'Marca el lead como derivado y arma el payload de handoff.',
  registrar_interes_reunion: 'Guarda intención y franja horaria como slots.',
  cerrar_fuera_de_mercado: 'Cierre cortés por gate CUT.',
  derivar_humano: 'Escala la conversación a un operador humano.',
};

export type LeadQualificationResult =
  | 'CALIFICADO'
  | 'REVISAR'
  | 'NO_CALIFICADO'
  | 'INSUFICIENTE';

export type LeadFsmState =
  | 'RELEVANDO'
  | 'FAST_PATH'
  | 'GATE_FALLIDO'
  | 'INSUFICIENTE'
  | 'DERIVADO'
  | 'OPT_OUT';

export interface LeadSlotPublic {
  slotKey: string;
  vertical: string;
  valueNumber: number | null;
  valueMin: number | null;
  valueMax: number | null;
  valueText: string | null;
  unit: string | null;
  valueLiteral: string;
  confidence: number;
  capturedBy: string;
  capturedAt: string;
  supersededAt?: string | null;
}

export interface LeadEventPublic {
  id: string;
  eventType: string;
  actor: string;
  ruleId: string | null;
  output: Record<string, unknown> | null;
  createdAt: string;
}

export interface LeadAttributionPublic {
  touch: 'FIRST' | 'LAST';
  source: string | null;
  medium: string | null;
  channel: string | null;
  funnelRoute: string | null;
  campaignId: string | null;
  campaignName: string | null;
  groupId: string | null;
  groupName: string | null;
  adId: string | null;
  adName: string | null;
  formId: string | null;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmContent: string | null;
  utmTerm: string | null;
  gclid: string | null;
  fbclid: string | null;
  ctwaClid: string | null;
  landingUrl: string | null;
  referrer: string | null;
  capturedAt: string;
}

export interface LeadCampaignRoutePublic {
  id: string;
  tenantId: string;
  source: string;
  externalCampaignId: string | null;
  externalGroupId: string | null;
  externalAdId: string | null;
  externalFormId: string | null;
  routeKey: string;
  enabled: boolean;
  note: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface LeadPublic {
  id: string;
  tenantId: string;
  agentId: string | null;
  contactId: string | null;
  conversationId: string | null;
  status: string;
  qualification: string;
  qualificationReason: string | null;
  score: number | null;
  ruleId: string | null;
  /** Resumen comercial redactado por IA al derivar el lead. */
  summary?: string | null;
  ownerUserId: number | null;
  fastPath: boolean;
  verticalDeclared: string | null;
  verticalResolved: string | null;
  verticalResolutionMethod?: string | null;
  verticalResolutionConfidence?: number | null;
  verticalLocked?: boolean;
  funnelRoute?: string | null;
  /** Etiqueta legible del vertical según la config activa del embudo. */
  verticalLabel?: string | null;
  companyName: string | null;
  contactName: string | null;
  sourceChannel: string | null;
  firstResponseAt: string | null;
  handoffAt: string | null;
  createdAt: string;
  updatedAt: string;
  slotValues?: LeadSlotPublic[];
  events?: LeadEventPublic[];
  attributions?: LeadAttributionPublic[];
}

export interface LeadFunnelConfigPublic {
  id: string;
  tenantId: string;
  version: number;
  status: string;
  checksum: string;
  note: string | null;
  appliedAt: string | null;
  createdAt: string;
}

export interface LeadFunnelConfigDetail extends LeadFunnelConfigPublic {
  payload: Record<string, unknown>;
}

export interface ImportLeadFunnelConfigRequest {
  payload: Record<string, unknown>;
  note?: string;
}

export const LEADS_LIMITS = {
  configPayloadMaxBytes: 512_000,
  listPageSize: 50,
  /** Tope de payload de intake: formularios Meta/web con campos extra; 1 MB evita abuso sin bloquear leads reales */
  intakePayloadMaxBytes: 1024 * 1024,
} as const;
